import Login from './Components/Login/Login'
import Signup from './Components/Signup/SignUp'
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import { useEffect, useState, useContext } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import { Row, Col } from 'antd'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { useNavigate } from 'react-router';
import Sider from './Components/Courses/Sider';
import Users from './Components/Masters/Users/Users';
import Modules from './Components/Masters/Modules/Modules';
import Courses from './Components/Masters/Courses/Courses';
import Scores from './Components/Masters/Scores/Scores';
import Course from './Components/Masters/Scores/Courses/Course';
import UserList from './Components/Masters/Analytics/UserList/UserList';
import Analytics from './Components/Masters/Analytics/Analytics';
import AddCourse from './Components/Masters/Courses/AddCourse/AddCourse';
import Teams from './Components/Masters/Teams/Teams';
import Assesment from './Components/Masters/Assesment/Assesment';
import CourseMapping from './Components/CourseMapping/CourseMapping';
import UserMapping from './Components/CourseMapping/UserMapping/UserMapping';
import ScoreUsers from './Components/Masters/Scores/Users/ScoreUsers'
import CourseCompletion from './Components/Masters/Scores/Users/CourseCompletion';
import TrainingModule from './Components/TrainingModule/TrainingModule';
import AddTraining from './Components/TrainingModule/AddTraining/AddTraining';
import TrainingMapping from './Components/TrainingMapping/TrainingMapping';
import TraininguserMapping from './Components/TrainingMapping/TraininguserMapping/TraininguserMapping';
import TrainingAssessment from './Components/TrainingAssessment/TrainingAssessment';
import UserReport from './Components/Masters/Scores/UserReport/UserReport';
import TrainingReport from './Components/Masters/Scores/TrainingReports/TrainingReport';
import TrainingCompletion from './Components/Masters/Scores/Users/TrainingCompletion';
import ManageCourse from './Components/Masters/Courses/ManageCourse/ManageCourse';
import ForgotPassword from './Components/ForgotPassword/ForgotPassword';
import PasswordChange from './Components/PasswordChange/PasswordChange';
import Settings from './Components/Settings/Settings';
import EmailConfig from './Components/EmailConfig/ConfigPage/EmailConfig';
import CourseTrainingPage from './Components/EmailConfig/CourseTrainingPage/CourseTrainingPage';
import SelectPage from './Components/EmailConfig/SelectPage/SelectPage';
import { BaseUrl } from './Components/Constants/Constants';
import axios from 'axios';
import Context from './Context/context';
import ProtectedLayout from './Layouts/ProtectedLayout';
import AuthLayout from './Layouts/AuthLayout';
import CoursePartReport from './Components/Masters/Scores/CoursePartTracker/CoursePartReport';
import FeedbackForms from './Components/FeedbackForms/FeedbackForms';
import FeedbackReport from './Components/FeedbackForms/FeedbackReport';
import EventUserResponse from './Components/EventUserResponseReport/EventUserResponseReport';
import CareerDevelopmentCourses from './Components/CareerDevelopmentCourses/CareerDevelopmentCourses';
import CareerDevelopmentDashboard from './Components/CareerDevelopmentCourses/CareerDevelopmentDashboard';
import CreateEvents from './Components/EventsModule/CreateEvents/CreateEvents';
import EventUserMapping from './Components/EventsModule/EventUserMapping/EventUserMapping';
import Coursedetail from './Components/CareerDevelopmentCourses/Coursedetail';
import CareerCourseMapping from './Components/CareerDevelopmentCourses/CareerCourseMapping';
import CareerDevelopmentReport from './Components/CareerDevelopmentCourses/CareerDevelopmentReport'
function App() {
  const { state, dispatch } = useContext(Context);

  const navigate = useNavigate();
  const [lastActivity, setLastActivity] = useState(Date.now());
  let url = window.location.href;
  let splittedUrl = url.split('/')[3];
  // console.log(splittedUrl,"url")

  const [Url, setUrl] = useState('')

  useEffect(() => {
    setUrl(splittedUrl)
  }, [splittedUrl])
  //cannot render page need to change 
  // console.log(Url,"urllll")

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const statusCode = error?.response?.data?.statusCode;
        const message = error?.response?.data?.message;

        if (
          (status === 401 || statusCode === 401) &&
          message === 'You are not authorized to access this resource.'
        ) {
          localStorage.setItem('IsAuthenticated', 'false');
          navigate('/login');
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);



  // useEffect(() => {
  //   // Your code to handle user activity
  //   const handleUserActivity = () => {
  //     setLastActivity(Date.now());
  //   };

  //   // Attach event listeners or use other mechanisms to track user activity
  //   window.addEventListener('mousemove', handleUserActivity);
  //   window.addEventListener('keydown', handleUserActivity);

  //   // Clean up the event listeners when the component unmounts
  //   return () => {
  //     window.removeEventListener('mousemove', handleUserActivity);
  //     window.removeEventListener('keydown', handleUserActivity);
  //   };
  // }, []);

  const INACTIVITY_TIMEOUT = 60 * 60 * 1000; //  60 minutes in milliseconds

  // useEffect(() => {
  //   const checkInactivity = () => {
  //     const currentTime = Date.now();
  //     if (currentTime - lastActivity > INACTIVITY_TIMEOUT) {
  //       // openNotificationWithIconError('User inactive. Logging out...')
  //       // console.log('User inactive. Logging out...');
  //       localStorage.setItem("IsAuthenticated", "false");
  //       setTimeout(() => {          
  //         if(splittedUrl !== 'login' && splittedUrl !== 'signup' && splittedUrl !== 'forgotpassword'){
  //           navigate('/login');
  //         }
  //       }, 500)
  //       // You may redirect to a logout page or dispatch a logout action.
  //     }
  //   };

  //   // Set up a timer to check inactivity at regular intervals
  //   const inactivityTimer = setInterval(checkInactivity, 1000); // Check every second

  //   // Clean up the timer when the component unmounts
  //   return () => {
  //     clearInterval(inactivityTimer);
  //   };
  // }, [lastActivity]);

    useEffect(() => {
    axios.get(`${BaseUrl}auth/admin/refresh`, {withCredentials:true})
      .then((res) => {
        dispatch({ type: "SET_IS_LOGGED_IN", payload: true });
        dispatch({ type: "SET_EMPLOYEE", payload: res?.data?.data?.employee });
        dispatch({ type: "SET_MANUAL_REFRESH", payload: false });
      })
      .catch((err) => {
        dispatch({ type: "SET_MANUAL_REFRESH", payload: false });
      })
  }, [])

  return (
    <>
<Routes>
    <Route element={<AuthLayout />}>
                <Route exact path="/login" element={<Login />}></Route>
                <Route exact path="/signup" element={<Signup />}></Route>
                <Route exact path="/forgotpassword" element={<ForgotPassword />}></Route>
                <Route exact path='/PasswordChange' element={<PasswordChange />}></Route>
    </Route>

    <Route element={<ProtectedLayout />}>
      <Route exact path='/settings' element={<Settings />}></Route>
                <Route exact path="/" element={<Users />}></Route>
                <Route exact path="/manageusers" element={<Users />}></Route>
                <Route exact path="/modules" element={<Modules />}></Route>
                <Route exact path="/managecourses" element={<Courses />}></Route>
                <Route exact path="/managecourses/:id" element={<ManageCourse />}></Route>
                <Route exact path="/managetrainings" element={<TrainingModule />}></Route>
                <Route exact path='/courses/:courseId' element={<AddCourse />}></Route>
                <Route exact path='/trainings/:trainingId' element={<AddTraining />}></Route>
                <Route exact path='/Reports' element={<ScoreUsers />}></Route>
                <Route exact path='/manageteams' element={<Teams />}></Route>
                <Route exact path='/Reports/:id' element={<Scores />}></Route>
                <Route exact path='/coursesactivityreports' element={<CourseCompletion />}></Route>
                <Route exact path='/trainingnoncompletionreports' element={<TrainingCompletion />}></Route>
                <Route exact path='/trainingreports' element={<TrainingReport />}></Route>
                <Route exact path='/courseParts' element={<CoursePartReport />}></Route>
                <Route exact path='/analytics' element={<UserList />}></Route>
                <Route exact path='/configureassessment' element={<Assesment />}></Route>
                {/* <Route exact path='/trainingassessment' element={<TrainingAssessment/>}></Route> */}
                <Route exact path='/analytics/:userId' element={<Analytics />}></Route>
                <Route exact path='/assigncourse' element={<CourseMapping />} ></Route>
                <Route exact path='/assigntrainings' element={<TrainingMapping />} ></Route>
                <Route exact path='/assigncourse/:type/:courseId' element={<UserMapping />}></Route>
                <Route exact path='/assigntrainings/:type/:trainingId' element={<TraininguserMapping />}></Route>
                <Route exact path='/userreports' element={<UserReport />} />
                <Route exact path='/emailconfigurations' element={<SelectPage />} />
                <Route exact path='/emailconfigurations/:type' element={<CourseTrainingPage />} />
                <Route exact path='/emailconfigurations/:type/:id' element={<EmailConfig />} />
                <Route exact path='/feedbackforms' element={<FeedbackForms />} />
                <Route exact path='/feedbackreports' element={<FeedbackReport />} />
                <Route exact path='/eventuserresponsereport' element={<EventUserResponse/>}/>
                <Route exact path='/create-events' element={<CreateEvents/>}/> 
                <Route exact path='/assignevents' element={<EventUserMapping />}></Route>  
                <Route exact path='/careerdevelopmentcourses' element={<CareerDevelopmentCourses/>}></Route>
                <Route exact path='/careerdevelopmentcourses/:courseId' element={<Coursedetail/>}></Route>
                <Route exact path='/careercourseassign/:courseId' element={<CareerCourseMapping/>}></Route>
                <Route exact path='/careerdevelopmentDashboard' element={<CareerDevelopmentDashboard/>}></Route>
                <Route exact path='/create-careerdevelopmentcourses' element={<CareerDevelopmentCourses/>}></Route>
                <Route exact path='/careerdevelopmentcoursesreport' element={<CareerDevelopmentReport/>}></Route>
                
    </Route>

    <Route path="*" element={<Navigate to="/login" />} />
    </Routes>

    </>
  );
}

export default App;
